import Calendar01Icon from '@/components/icons/Calendar01Icon';
import Calendar03Icon from '@/components/icons/Calendar03Icon';
import { Button } from '@/components/ui/button';
import { FC } from 'react';

type Props = {
	viewMode: 'month' | 'year';
	setViewMode: (viewMode: 'month' | 'year') => void;
};

const CalendarPeriodSwitcher: FC<Props> = ({viewMode, setViewMode}) => {
	return (
		<div className='h-11 shrink-0 border border-popover-100 rounded-full bg-popover-10'>
			<Button
				variant={`${
					viewMode === 'month' ? 'default' : 'outline'
				}`}
				size={'icon'}
				className={`size-[42px] border-none hover:shadow-none ${
					viewMode === 'month' ? '' : 'hover:bg-primary-color-50'
				}`}
				onClick={() => setViewMode('month')}>
				<Calendar01Icon
					className={`${
						viewMode === 'month' ? 'stroke-popover-10' : ''
					}`}
				/>
			</Button>
			<Button
				variant={`${
					viewMode === 'year' ? 'default' : 'outline'
				}`}
				size={'icon'}
				className={`size-[42px] border-none hover:shadow-none ${
					viewMode === 'year' ? '' : 'hover:bg-primary-color-50'
				}`}
				onClick={() => setViewMode('year')}>
				<Calendar03Icon
					className={`${
						viewMode === 'year' ? 'stroke-popover-10' : ''
					}`}
				/>
			</Button>
		</div>
	);
};

export default CalendarPeriodSwitcher;
